import { Grid } from "@mui/material";
import styles from "./AddFarmBillingEntity.module.scss";
import Dropdown from "../../components/DropDown";
import { customStyle } from "../../styles/serviceAgreement";
import { useAddFarm } from "../../hooks/useAddFarmBillingEntity";
import InputTextField from "../../components/TextField";

export const LandlordField = () => {
  const {
    newLandlordFieldMapping,
    landlordError,
    fieldError,
    acresError,
    farmNameOptions,
    fieldOptions,
    handleFieldLandlordChange,
    handleFieldChange,
    handleAcreChange,
    handleSaveLandlordFieldMapping,
    handleCancel,
  } = useAddFarm();
  return (
    <div className={styles.formContainer}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Dropdown
            label="Landlord"
            value={
              newLandlordFieldMapping.landlordId
                ? farmNameOptions.find(
                    (opt) => opt.id === newLandlordFieldMapping.landlordId
                  )
                : null
            }
            options={farmNameOptions}
            customStyles={{
              ...customStyle,
              menuList: (provided) => ({
                ...provided,
                maxHeight: "100px",
              }),
            }}
            isClearable
            isDisabled={false}
            placeholder="Select Landlord"
            onChange={handleFieldLandlordChange}
            error={!!landlordError}
            helperText={landlordError}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Dropdown
            label="Field"
            value={
              newLandlordFieldMapping.fieldId
                ? fieldOptions.find(
                    (opt) => opt.id === newLandlordFieldMapping.fieldId
                  )
                : null
            }
            options={fieldOptions}
            customStyles={{
              ...customStyle,
              menuList: (provided) => ({
                ...provided,
                maxHeight: "100px",
              }),
            }}
            isClearable
            isDisabled={false}
            placeholder="Select Field"
            onChange={handleFieldChange}
            error={!!fieldError}
            helperText={fieldError}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InputTextField
            label="Acres"
            placeholder="Enter Acres"
            name="acres"
            type="number"
            value={newLandlordFieldMapping.acre || ""}
            onChange={handleAcreChange}
            className={styles.inputText}
            error={!!acresError}
            helperText={acresError}
          />
        </Grid>
      </Grid>
      <div className={styles.buttonContainer} style={{ marginTop: "1rem" }}>
        <button className={styles.cancelButton} onClick={handleCancel}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={handleSaveLandlordFieldMapping}>
          Add
        </button>
      </div>
    </div>
  );
};
